import { toArray } from "lib/utils";

export function createBody(queryParams, pastEventDate) {
  try {
    const now = new Date();
    const qsDate = queryParams["eventDate"] || pastEventDate;
    const { eventLocation, eventLanguage, Analyst } = queryParams;

    const strToDateMap = {
      "1month": new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30),
      ytd: new Date(now.getFullYear(), 0, 1),
      "1year": new Date(now.getFullYear() - 1, now.getMonth(), now.getDate()),
      "+1year": new Date(now.getFullYear() + 1, now.getMonth(), now.getDate()),
    };

    const request = {
      startDate: strToDateMap[qsDate],
      endDate: strToDateMap["+1year"],
      hashtags: ["#MacroBrew"],
      ...(eventLocation && { locationCategory: eventLocation }),
      ...(eventLanguage && { language: eventLanguage }),
      ...(Analyst && { speakerDisplayName: toArray(Analyst) }),
    };

    return JSON.stringify(request);
  } catch (err) {
    console.error("Could not create event request: ", err);
  }
}
